import { FC, createContext, useContext, useState, ReactNode } from "react";
import { StartupMessage } from "../transports/startup";

export interface StartupContextModel {
    startupMessage: StartupMessage | null;
    setStartupMessage: (values: any) => void;
}

const StartupContext = createContext<StartupContextModel>({
    startupMessage: null,
    setStartupMessage: (_values: any) => {},
});

export const StartupProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [startupMessage, setStartupMessage] = useState<StartupMessage | null>(null);

    const value: StartupContextModel = {
        startupMessage,
        setStartupMessage,
    };

    return <StartupContext.Provider value={value}>{children}</StartupContext.Provider>;
};

export function useStartup() {
    return useContext(StartupContext);
}
